import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, Home, ArrowRight } from 'lucide-react';

const Thanks = () => {
  useEffect(() => {
    document.title = 'Thank You - Zorvian Associates';
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 flex items-center justify-center px-4">
      <div className="max-w-2xl w-full">
        {/* Thank You Card */}
        <div className="bg-white rounded-2xl shadow-2xl p-8 md:p-12 text-center">
          {/* Success Icon */}
          <div className="mb-6 flex justify-center">
            <div className="bg-green-100 rounded-full p-6">
              <CheckCircle className="h-16 w-16 text-green-600" />
            </div>
          </div>

          {/* Thank You Message */}
          <h1 className="text-4xl md:text-5xl font-bold text-[#0F172A] mb-4 font-heading">
            Thank You!
          </h1>
          
          <p className="text-xl text-slate-600 mb-8">
            We've received your message and appreciate you reaching out to Zorvian Associates.
          </p>

          <div className="bg-blue-50 border-l-4 border-[#2563EB] p-6 mb-8 text-left">
            <h2 className="text-lg font-bold text-[#0F172A] mb-2">What Happens Next?</h2>
            <ul className="space-y-2 text-slate-700">
              <li className="flex items-start">
                <ArrowRight className="h-5 w-5 text-[#2563EB] mr-2 flex-shrink-0 mt-0.5" />
                <span>Our legal team will review your inquiry within 24 hours</span>
              </li>
              <li className="flex items-start">
                <ArrowRight className="h-5 w-5 text-[#2563EB] mr-2 flex-shrink-0 mt-0.5" />
                <span>An attorney will contact you to discuss your legal needs</span>
              </li>
              <li className="flex items-start">
                <ArrowRight className="h-5 w-5 text-[#2563EB] mr-2 flex-shrink-0 mt-0.5" />
                <span>We'll schedule a consultation at your convenience</span>
              </li>
            </ul>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/"
              className="inline-flex items-center justify-center px-6 py-3 bg-[#2563EB] text-white font-semibold rounded-lg hover:bg-[#1d4ed8] transition-colors"
            >
              <Home className="h-5 w-5 mr-2" />
              Return to Homepage
            </Link>
            <Link
              to="/services"
              className="inline-flex items-center justify-center px-6 py-3 border-2 border-[#2563EB] text-[#2563EB] font-semibold rounded-lg hover:bg-blue-50 transition-colors"
            >
              Explore Our Services
            </Link>
          </div>

          {/* Contact Info */}
          <div className="mt-8 pt-8 border-t border-slate-200">
            <p className="text-sm text-slate-600">
              Need immediate assistance? Call us at{' '}
              <a href="tel:+18449212228" className="text-[#2563EB] font-semibold hover:underline">
                +1 (844) 921-2228
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Thanks;
